import { Component, HostBinding } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { RenderByDeviceService } from 'render/services/base-render-by-device/render-by-device.service';

import { PieceTableRenderField, PieceTableRenderSettings } from './piece-table.models';


@Component({
  selector: 'piece-table-render',
  templateUrl: './piece-table-render.component.html',
  styleUrls: ['./piece-table-render.component.scss']
})
export class PieceTableRenderComponent
  extends BaseRenderComponent<PieceTableRenderSettings> {

  constructor(
    private readonly renderByDeviceService: RenderByDeviceService
  ) {
    super();
  }

  @HostBinding('style.--max-columns')
  public get maxColumns(): number {
    let maxColumns: number | undefined;
    if (this.renderByDeviceService.isMobile) {
      maxColumns = this.settings.general.tableStyles.tableColumns.tableColumnsMobile;
    } else {
      maxColumns = this.settings.general.tableStyles.tableColumns.tableColumnsDesktop;
    }
    return maxColumns ?? this.tableContent.length;
  }

  @HostBinding('style.--total-columns')
  public get totalColumns(): number {
    return this.tableContent[0]?.length ?? 0;
  }

  @HostBinding('class')
  public get classes(): string {
    return this.settings.styles.customClassesList ?? '';
  }

  public get tableContent(): PieceTableRenderField[][] {
    return (this.settings.general.tableContent ?? []);
  }

  public get isFirstColumnSticky(): boolean {
    return this.settings.general.tableStyles.firstColumnSticky;
  }

  public get isFirstRowSticky(): boolean {
    return this.settings.general.tableStyles.firstRowSticky;
  }

  public trackByIndex(index: number): number {
    return index;
  }

}
